import { useCallback } from "react";

import { useUserPreferences } from "@/context/UserPreferencesContext";
import {
  formatDatePlain,
  formatDateWithWeek,
  toWeekLabel,
} from "@/lib/weekDates";

export function useDateFormatter() {
  const { preferences } = useUserPreferences();
  const showWeek = preferences.showWeekNumbers;

  const formatDate = useCallback(
    (dateStr: string | null | undefined) =>
      showWeek ? formatDateWithWeek(dateStr) : formatDatePlain(dateStr),
    [showWeek],
  );

  const weekLabel = useCallback(
    (dateStr: string | null | undefined) =>
      showWeek ? toWeekLabel(dateStr) : null,
    [showWeek],
  );

  return { formatDate, weekLabel, showWeek };
}
